"use strict";
const rangoFechasFilter = require("./rangoFechas");
const valorUnicoFilter = require("./valorUnico");
const busquedaTexto = require("./busquedaTexto");
const ret = {
    rangoFechas: rangoFechasFilter.filtro,
    valodUnico: valorUnicoFilter.filtro,
    busquedaTexto: busquedaTexto.filtro
};
module.exports = ret;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/index.js
// module id = 2230
// module chunks = 0